__turbopack_context__.v({
  "label": "_80PLMG_label",
  "option": "_80PLMG_option",
  "price": "_80PLMG_price",
  "root": "_80PLMG_root",
  "saveBadge": "_80PLMG_saveBadge",
  "selected": "_80PLMG_selected",
});
